import React, { useState, useEffect } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { getUsers } from '../../../services/userservice';
import { API_URL } from "../../../config";
import companyDefaultImage from "../../../assets/images/companyImg.jpg"
import defaultProfileImage from "../../../assets/images/user/img-02.jpg";
import { useProfile, useValidUserId, useUserRole } from '../../../hooks';
import { createMountedRef } from '../../../utils/validation';


const LeftSideContent = ({ userId }) => {
  const [user, setUser] = useState("");
  const [src, setSrc] = useState("");
  
  const { userId: currentUserId, isValid } = useValidUserId();
  const { profile: perfil, isCompany: userIsCompany } = useProfile();
  const rol = useUserRole();

  // photo puede ser URL completa (Cloud Storage) o solo nombre de archivo (backend /download2)
  const getPhotoUrl = (photo) => {
    if (!photo) return null;
    if (typeof photo === "string" && photo.startsWith("http")) return photo;
    return `${API_URL}/download2/${photo}`;
  };

  // Cargar datos del usuario
  useEffect(() => {
    const { isMountedRef, cleanup } = createMountedRef();

    if (!isValid) return cleanup;

    getUsers(currentUserId)
      .then(userData => {
        if (isMountedRef.current) {
          setUser(userData);
        }
      })
      .catch(error => console.error(error));

    return cleanup;
  }, [currentUserId, isValid]);
  // Actualizar imagen de perfil
  useEffect(() => {
    const photoUrl = getPhotoUrl(perfil?.photo);
    if (photoUrl) {
      const timestamp = new Date().getTime();
      setSrc(`${photoUrl}${photoUrl.includes("?") ? "&" : "?"}t=${timestamp}`);
    } else {
      setSrc(userIsCompany ? companyDefaultImage : defaultProfileImage);
    }
  }, [perfil?.photo, userIsCompany]);

  return (
    <React.Fragment>
      <Col lg={4}>
        <Card className="profile-sidebar me-lg-4">
          <CardBody className="p-4">
            <div className="text-center pb-4 border-bottom">
              <img
                src={src}
                style={{objectFit: "cover"}}
                alt=""
                className="avatar-lg img-thumbnail rounded-circle mb-4"
                onError={(e) => { rol === '1' ? e.target.src = companyDefaultImage: e.target.src = defaultProfileImage; }}

              />
              <h5 className="mb-0">{user ? user.username : "Cargando..."}</h5>
              <p className="text-muted">{user ? user.email : "Cargando..."}</p>
              {/* Resto del contenido */}
            </div>
            {/* Resto de las secciones */}
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default LeftSideContent;
